export default "__VITE_ASSET__d5f38b2e__"